// Credit moved between registrations reads as credit, not as the card it
// was first paid with (Amanda, 2026-10-20: "it will be confusing, both for
// the user and the admin to see this referenced as a transaction from a
// card, rather than the application of an existing credit").
//
// The portal API (camp360portalapi src/repositories/creditMove.ts) marks
// such lines with creditMove: 'applied' (credit paid this registration),
// 'toBalance' (credit moved to the family's balance) or 'source' (the
// Transfer line on the registration the credit came from). It answers their
// type ("Credit applied", "Transfer"), how they were paid ("Account credit")
// and a description ("Credit from <event>", "Credit moved to <event>"). The
// line keeps the charge id of the card payment the credit came from (a
// refund goes back to it); the family sees where the credit came from
// instead of that card's charge id.

export const ACCOUNT_CREDIT = "Account credit";

export type TransactionRow = {
  transactionID?: string | number;
  description?: string;
  creditMove?: string;
};

export const isCreditMove = (item?: { creditMove?: string } | null) =>
  !!(item && item.creditMove);

// The small line under a transaction in the Finance page log and the
// Transactions page: the charge id, or for credit where it came from.
export const transactionSubline = (item: TransactionRow) =>
  isCreditMove(item)
    ? item.description || ""
    : `${item.transactionID === undefined ? "" : item.transactionID}`;

// The transaction details window, next to the type: how it was paid when
// it was credit ("" for anything else).
export const detailsPaymentNote = (details?: { paymentType?: string } | null) =>
  details && details.paymentType === ACCOUNT_CREDIT
    ? `Paid with ${ACCOUNT_CREDIT.toLowerCase()}`
    : "";

// The payment plan window's payment column: "Credit Card (Visa) - 4242" as
// before for a card payment, "Transfer - Account credit" for credit moved
// off the plan's registration (never the card's last 4).
export const planLinePayment = (item: {
  typeName?: string;
  transactionLast4?: string | null;
  paymentType?: string;
}) =>
  item.paymentType === ACCOUNT_CREDIT
    ? `${item.typeName || ""} - ${ACCOUNT_CREDIT}`
    : `${item.typeName || ""}${
        item.typeName == "Credit Card" ? " (Visa)" : ""
      } - ${item.transactionLast4 || ""}`;
